import { createSelector } from 'reselect';
import { getWorkspaceID } from './workspaces';

const getRawLabelGroups = state => state.labelGroups;

export const getWorkspaceLabelGroups = createSelector(
	[ getRawLabelGroups, getWorkspaceID ],
	( labelGroups, workspaceID ) => {
		if ( !labelGroups || labelGroups.workspace_id !== workspaceID ) {
			return { workspace_label_groups: [], project_label_groups: [] };
		}
		return labelGroups;
	}
);
